'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type Dispatch, type ReactNode, useMemo, useReducer } from 'react';
import type { AnswerAction } from './actions';
import { initialAnswerStore, reducer } from './reducer';
import type { AnswerStore } from './types';
type AnswerStoreContextValue = {
  store: AnswerStore;
  dispatch: Dispatch<AnswerAction>;
};
export const AnswerStoreContext = createContext<AnswerStoreContextValue | undefined>(undefined);
export function AnswerStoreProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [store, dispatch] = useReducer(reducer, initialAnswerStore);
  let t1;
  if ($[0] !== store) {
    t1 = {
      store,
      dispatch
    };
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <AnswerStoreContext.Provider value={value}>{children}</AnswerStoreContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}